import React from 'react'
import ReactDOM from 'react-dom';
import classNames from "classnames";
import { withNamespaces } from "react-i18next";
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import Button from "components/CustomButtons/Button.jsx";
import IconButton from '@material-ui/core/IconButton';
import Icon from "@material-ui/core/Icon";
import Popper from "@material-ui/core/Popper";
import Paper from "@material-ui/core/Paper";
import Grow from "@material-ui/core/Grow";
import Divider from "@material-ui/core/Divider";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';

import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import mapStyle from "assets/jss/prehnit/components/mapStyle.jsx";

//OpenLayers
import OlFormatGPX from "ol/format/GPX";
import OlFormatKML from "ol/format/KML";
import OlFormatGeoJSON from "ol/format/GeoJSON";

import shp from "shpjs";

const FTYPE_GPX = "application/gpx+xml";
const FTYPE_KML = "application/vnd.google-earth.kml+xml";
const FTYPE_ZIP = "application/zip";

const GPX_PROJ = "EPSG:4326";
const KML_PROJ = "EPSG:4326";
const FEATURES_PROJ = "EPSG:3765";


class OverlaySwitcher extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      open: false,
      dialogOpen: false,

      uploadFileName: '',
      uploadFiles: undefined,
      uploadResult: undefined,
    }

    this.handleClick = this.handleClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
    this.handleCloseMenu = this.handleCloseMenu.bind(this);
    this.handleDeleteMenuItem = this.handleDeleteMenuItem.bind(this);

    this.setOpen = this.setOpen.bind(this);
    this.handleClickOpen = this.handleClickOpen.bind(this);
    this.handleDialogClose = this.handleDialogClose.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleFileLoad = this.handleFileLoad.bind(this);
  }

  handleClick = () => {
    this.setState(state => ({
      open: !state.open,
    }));
  };

  handleClose = event => {
    if (this.anchorEl.contains(event.target)) {
      return;
    }
    this.setState({ open: false });
  };

  handleAdd = event => {
    this.handleClickOpen();
  };

  setOpen(val) {
    if (val === true) {
      this.setState({
        dialogOpen: val,
        uploadFileName: ''
      });
    } else {
      this.setState({
        dialogOpen: val
      });
    }

  }

  handleClickOpen() {
    this.setOpen(true);
  }

  handleDialogClose() {
    this.setState({
      dialogOpen: false,
      // uploadFileName: '',
      uploadFiles: null
    });
  }

  handleCloseMenu(param) {
    this.setState({
      open: false,
      selectedLayerId: param.id,
      selectedLayerName: param.layer
    });
    if (this.props && this.props.onSelect) {
      this.props.onSelect(param);
    }
  };

  handleDeleteMenuItem(param) {
    this.setState({
      open: false
    });
    if (this.props && this.props.onRemove) {
      this.props.onRemove(param);
    }
  }

  loadGPX(data) {
    return (new OlFormatGPX()).readFeatures(data, {
      dataProjection: GPX_PROJ,
      featureProjection: FEATURES_PROJ
    });
  }

  loadKML(data) {
    return (new OlFormatKML()).readFeatures(data, {
      dataProjection: KML_PROJ,
      featureProjection: FEATURES_PROJ
    });
  }

  loadSHP(data) {
    let name = this.state.uploadFileName;

    var buffer = Buffer.from(data);
    shp(buffer)
      .then(function (geojson) {
        let features = (new OlFormatGeoJSON()).readFeatures(geojson, {
          featureProjection: FEATURES_PROJ
        });

        if (this.props.onAdd) {
          this.props.onAdd(features, name);
        }

        this.handleDialogClose();
      }.bind(this))
      .catch(error => console.log(error));

  }

  handleFileChange(evt) {
    this.setState({
      uploadFileName: evt.target.files[0].name,
      uploadFiles: evt.target.files,
    });
  }

  getExtension(filename) {
    let ind = filename.lastIndexOf('.');
    let ext = filename.substring(ind + 1);
    return ext.toLowerCase();
  }

  handleFileLoad() {
    let files = this.state.uploadFiles; // FileList object
    if (files) {

      // files is a FileList of File objects. List some properties.
      for (let i = 0, f = files[i]; i < files.length; i++) {
        let reader = new FileReader();
        let ext = this.getExtension(f.name);

        if (f.type === FTYPE_GPX || ext === "gpx") {
          reader.onload = function (evt) {
            let features = this.loadGPX(evt.target.result);
            if (this.props.onAdd) {
              this.props.onAdd(features, this.state.uploadFileName);
            }
          }.bind(this);
          reader.readAsText(f, "UTF-8");
        } else if (f.type === FTYPE_KML || ext === "kml") {
          reader.onload = function (evt) {
            let features = this.loadKML(evt.target.result);
            if (this.props.onAdd) {
              this.props.onAdd(features, this.state.uploadFileName);
            }
          }.bind(this);
          reader.readAsText(f, "UTF-8");

        } else if (f.type === FTYPE_ZIP || ext === "zip") {
          reader.onload = function (evt) {
            this.loadSHP(evt.target.result);
          }.bind(this);
          reader.readAsArrayBuffer(f);

        } else {
          console.warn('Upload layer: Unsupported file format!', f.type);
        }

        // console.log(f.type);
        // reader.readAsText(f, "UTF-8");
        // reader.onload = function (evt) {
        //   let features = [];
        //   let file_parsed = false;
        //   if (f.type === FTYPE_GPX) {
        //     features = this.loadGPX(evt.target.result);
        //     file_parsed = true;
        //   } else if (f.type === FTYPE_KML) {

        //     file_parsed = true;
        //   } else if (f.type === FTYPE_ZIP) {
        //     this.loadSHP(evt.target.result);
        //     return; //handled through load fnc
        //   }

        //   if (file_parsed && this.props.onAdd) {
        //     this.props.onAdd(features, this.state.uploadFileName);
        //   }

        // }.bind(this);
      }
    }
    this.handleDialogClose();
  };

  openFileDialog() {
    var fileUploadDom = ReactDOM.findDOMNode(this.refs.fileUpload);
    fileUploadDom.click();
  };

  render() {
    const { t, classes,
      buttonText, buttonIcon,
      hoverColor, noLiPadding, layersList, dropup, navDropdown
    } = this.props;
    const { open } = this.state;


    const dropdownItem = classNames({
      [classes.dropdownItem]: true,
      [classes[hoverColor + "Hover"]]: true,
      [classes.noLiPadding]: noLiPadding
    });

    const menu = (
      <MenuList role="menu" className={classes.menuList}>
        {layersList.map((prop, key) => {
          return (
            <MenuItem
              key={key}
              onClick={() => this.handleCloseMenu(prop)}
              className={dropdownItem}
            >
              <Icon className={classes.dropdownIcons}>{prop.icon ? prop.icon : "layers"}</Icon>
              {prop.name}
              <ListItemSecondaryAction>
                <IconButton aria-label="Delete" className={classes.secondaryActionButton} onClick={() => this.handleDeleteMenuItem(prop)}>
                  <Icon className={classes.secondaryActionButtonIcon}>delete</Icon>
                </IconButton>
              </ListItemSecondaryAction>
            </MenuItem>
          );
        })}
        {layersList && layersList.length > 0 ?
          <Divider
            key="999"
            onClick={() => this.handleCloseMenu("divider")}
            className={classes.dropdownDividerItem}
          /> : null}

        <MenuItem
          key="1001"
          onClick={() => this.handleAdd()}
          className={dropdownItem}
        >
          <Icon className={classes.dropdownIcons}>add</Icon>
          {t("map:overlay-add")}
        </MenuItem>


      </MenuList>
    );

    return (
      <div className={classes.manager}>
        <div className={classNames(buttonText !== undefined ? "" : classes.target)}>
          <Button
            aria-label="Overlays"
            aria-owns={open ? "menu-list-overlays" : null}
            aria-haspopup="true"
            buttonRef={node => {
              this.anchorEl = node;
            }}
            color="primary"
            onClick={this.handleClick}
            className={classes.smallButton}
          >
            <Icon className={classes.smallButtonIcon}>{buttonIcon}</Icon>
          </Button>


          <Popper
            open={open}
            anchorEl={this.anchorEl}
            transition
            disablePortal
            placement="bottom"
            className={classNames({
              [classes.popperClose]: !open,
              [classes.pooperResponsive]: true,
              [classes.pooperNav]: open && navDropdown
            })}
          >
            {({ TransitionProps, placement }) => (
              <Grow
                in={open}
                id="menu-list-overlays"
                style={
                  dropup
                    ? { transformOrigin: "0 100% 0" }
                    : { transformOrigin: "0 0 0" }
                }
              >
                <Paper className={classes.dropdown}>
                  <ClickAwayListener onClickAway={this.handleClose} ref="cacat">
                    {menu}
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>

        </div>

        <Dialog open={this.state.dialogOpen} onClose={this.handleDialogClose} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">{t("map:upload-title")}</DialogTitle>
          <DialogContent>
            <DialogContentText>{t("map:upload-desc")}</DialogContentText>
            <input
              ref="fileUpload"
              className={classes.input}
              style={{ display: 'none' }}
              id="button-file"
              type="file"
              onChange={this.handleFileChange}
            />
            <label htmlFor="button-file">
              <Button variant="raised" component="span" className={classNames(classes.button, classes.warning)} onChange={this.openFileDialog}>
                {t('map:upload-browse')}
              </Button>
              <TextField
                ref="fileText"
                className={classes.input}
                id="file-text"
                disabled
                value={this.state.uploadFileName}
              />
            </label>

          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleDialogClose} color="danger">
              {t("common:cancel")}
            </Button>
            <Button onClick={this.handleFileLoad} color="primary">
              {t("common:ok")}
            </Button>
          </DialogActions>
        </Dialog>

      </div>
    );
  }
}

OverlaySwitcher.defaultProps = {
  dropup: false,
  hoverColor: "primary",
  buttonIcon: "timeline",
  buttonProps: {
    round: false,
    block: true,
    color: "primary"
  },
};

OverlaySwitcher.propTypes = {
  classes: PropTypes.object.isRequired,
  hoverColor: PropTypes.oneOf([
    "dark",
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "rose"
  ]),
  buttonText: PropTypes.node,
  buttonIcon: PropTypes.string,
  layersList: PropTypes.array,
  buttonProps: PropTypes.object,
  dropup: PropTypes.bool,
  dropdownHeader: PropTypes.node,
  rtlActive: PropTypes.bool,
  caret: PropTypes.bool,
  dropPlacement: PropTypes.oneOf([
    "bottom",
    "top",
    "right",
    "left",
    "bottom-start",
    "bottom-end",
    "top-start",
    "top-end",
    "right-start",
    "right-end",
    "left-start",
    "left-end"
  ]),
  noLiPadding: PropTypes.bool,
  innerDropDown: PropTypes.bool,
  navDropdown: PropTypes.bool,
  // This is a function that returns the clicked menu item
  onClick: PropTypes.func
};

export default withNamespaces()(withStyles(mapStyle)(OverlaySwitcher));;